import { useState } from 'react';
import GroupMembersPanel from './GroupMembersPanel';
import GroupCourses from './GroupCourses';
import GroupTestsWidget from './GroupTestsWidget';
import language from '../../variables/language';

// Учні групи / Курси групи / Тести used to be their own three equal-width
// columns (see the now-removed .group-card-columns-3-equal row in
// GroupCard.jsx) - folded into one tab-switched widget so they keep the
// same footprint one of those three columns had, freeing the rest of that
// row for GroupLessonsList. Each tab remounts its panel on switch (same
// "re-fetch on tab change" convention StudentCard.jsx's own top-level tabs
// use) rather than keeping all three mounted and hidden.
const TABS = ['members', 'courses', 'tests'];

export default function GroupSidebarTabs({ groupId, refresh, onChange }) {
   const [activeTab, setActiveTab] = useState(TABS[0]);
   const lang = language[language.lang];

   return (
      <div className='group-card-section group-sidebar-tabs'>
         <div className='group-sidebar-tabs-bar'>
            <div className={'group-sidebar-tab' + (activeTab === 'members' ? ' active' : '')}
               onClick={() => setActiveTab('members')}>{lang.groupCard.membersTitle}</div>
            <div className={'group-sidebar-tab' + (activeTab === 'courses' ? ' active' : '')}
               onClick={() => setActiveTab('courses')}>{lang.groupCard.coursesTitle}</div>
            <div className={'group-sidebar-tab' + (activeTab === 'tests' ? ' active' : '')}
               onClick={() => setActiveTab('tests')}>{lang.groupCard.testsTitle}</div>
         </div>
         <div className='group-sidebar-tab-content'>
            {activeTab === 'members' ? <GroupMembersPanel bare groupId={groupId} refresh={refresh} onChange={onChange} /> : ''}
            {activeTab === 'courses' ? <GroupCourses bare groupId={groupId} refresh={refresh} /> : ''}
            {activeTab === 'tests' ? <GroupTestsWidget bare groupId={groupId} refresh={refresh} /> : ''}
         </div>
      </div>
   );
}
